import barba from '@barba/core'
import primaryOnce from '@modules/pageTransitions/PrimaryOnce'

window.barba = barba

export default () => {
    barba.hooks.beforeOnce(() => {
        Alpine.start()
    })

    barba.hooks.beforeEnter(() => {
        setTimeout(() => {
            ScrollTrigger.refresh()
        }, 200)
    })

    barba.hooks.afterEnter(() => {
        setTimeout(() => {
            Alpine.store('audioPause', false)
        }, 500)
    })

    barba.hooks.beforeLeave(() => {})

    barba.hooks.leave(() => {
        Alpine.store('audioPause', true)
    })

    barba.hooks.afterLeave(() => {
        Alpine.store('enterDelay', 0)
        Alpine.store('nav').dropdown = false
        Alpine.store('nav').activeItem = false
        Alpine.store('nav').close()
    })

    barba.hooks.after(() => {
        ga('set', 'page', window.location.pathname)
        ga('send', 'pageview')
    })

    if (history.scrollRestoration) {
        history.scrollRestoration = 'manual'
    }

    barba.init({
        timeout: 20000,
        prevent: ({ el }) => el.classList && el.classList.contains('no-transition'),
        transitions: [
            {
                once() {
                    primaryOnce()
                },
                leave(data) {
                    const done = this.async()
                    done()
                },
                enter() {
                    window.scrollTo(0, 0)
                },
            },
        ],
        schema: {
            prefix: 'data-portal',
            wrapper: 'realm',
            container: 'destination',
        },
    })
}
